import React from "react";

export const EmailIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 2a8 8 0 1 0 3.75 15.05.75.75 0 0 0-.7-1.33A6.5 6.5 0 1 1 16.5 10v.75a1.75 1.75 0 0 1-3.5 0V7a.75.75 0 0 0-1.42-.34A3.5 3.5 0 1 0 13 12.17a3.24 3.24 0 0 0 5-.17V10a8 8 0 0 0-8-8Zm2 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      clipRule="evenodd"
    />
  </svg>
);
